import { render, staticRenderFns } from "./FoodDialog.vue?vue&type=template&id=675238a7&scoped=true"
import script from "./FoodDialog.vue?vue&type=script&lang=js"
export * from "./FoodDialog.vue?vue&type=script&lang=js"
import style0 from "./FoodDialog.vue?vue&type=style&index=0&id=675238a7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675238a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050store/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('675238a7')) {
      api.createRecord('675238a7', component.options)
    } else {
      api.reload('675238a7', component.options)
    }
    module.hot.accept("./FoodDialog.vue?vue&type=template&id=675238a7&scoped=true", function () {
      api.rerender('675238a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/components/FoodDialog.vue"
export default component.exports